import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "visit-attachments-hh" }
const _hoisted_2 = { class: "doc-header py-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "d-inline mr-auto" }, "Attachments")
], -1 /* HOISTED */)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_11 = {
  key: 0,
  class: "blinking-content"
}
const _hoisted_12 = ["onClick", "disabled"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Loading attachments...", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-8" }, null, -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "doc-body mt-3" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, " Use the upload field below to upload files associated with the schedule task. ", -1 /* HOISTED */)
const _hoisted_20 = { class: "upload-document mt-1" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "mt-2 py-2" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.loadingAttachments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, "There are " + _toDisplayString(_ctx.taskAttchments.length) + " attachment(s).", 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskAttchments, (attachment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: attachment.AssetId
              }, [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  onClick: ($event: any) => (_ctx.downloadDocuments(attachment))
                }, _toDisplayString(attachment.FileName), 9 /* TEXT, PROPS */, _hoisted_5),
                _hoisted_6,
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  type: "button",
                  class: "btn table-btn btn-outline-info au-target",
                  onClick: ($event: any) => (_ctx.openSelectedDocument(attachment))
                }, _hoisted_9, 8 /* PROPS */, _hoisted_7)), [
                  [_directive_tooltip, { title: 'View' }]
                ]),
                (_ctx.deletePatientDocumentsPermission || _ctx.editPatientDocumentsPermission)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_10,
                      (_ctx.isDeleteInProgress && _ctx.attachmentToDelete === attachment?.AssetId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Deleting document..."))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.requestDelete(attachment)),
                            disabled: _ctx.isPlanner
                          }, "Delete", 8 /* PROPS */, _hoisted_12))
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadingCount, (i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, _hoisted_16))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.addPatientDocumentsPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("input", {
                type: "file",
                ref: "file1",
                disabled: _ctx.uploading || _ctx.isPlanner,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFilesChanged($event))),
                class: "file-input border my-1 d-block"
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_21)
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_ctx.uploading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_25))
                : (_openBlock(), _createElementBlock("span", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveAttachments())),
                      disabled: _ctx.isPlanner
                    }, " Save Attachment ", 8 /* PROPS */, _hoisted_27)
                  ]))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}